import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import Social from 'profile/components/social';

export default connect(mapProfileToProps)(Social);



// WEBPACK FOOTER //
// ./profile/containers/social.js